module.exports = __webpack_public_path__ + "img/slide8.c4ceba4b.png";